/**
 * @description Validator types, e.g. regex, required, etc..
 */
export enum FormValidatorType {
  Required = 'Required',
  Regex = 'Pattern',
  MinValue = 'MinValue',
  MaxValue = 'MaxValue',
  MinLength = 'MinLength',
  MaxLength = 'MaxLength',
  Custom = 'Custom',
  RelativeMinDate = 'RelativeMinDate',
  RelativeMaxDate = 'RelativeMaxDate',
  BirthDate ='BirthDate',
  PixError = 'PixError',
  BreBError = 'BreBError'
}



// WEBPACK FOOTER //
// ./src/providers/formbuilder/form-validator-type.ts